import { type UseFormReturn } from "react-hook-form";
import { useIntl } from "react-intl";

import { BasicForm } from "../../components/form";
import {
  type SentryErrorFeedbackValues,
  sentryErrorFeedbackSchema,
} from "../schemas/sentry-error-feedback";
import { captureSentryFeedback } from "../utils/capture-feedback";
import { SentryErrorFeedbackFormFields } from "./sentry-error-feedback-form-fields";

export function SentryErrorFeedbackForm({ eventId }: { eventId: string }) {
  const intl = useIntl();

  const handleSubmit = async (
    { file, message }: SentryErrorFeedbackValues,
    form: UseFormReturn<SentryErrorFeedbackValues>,
  ) => {
    form.clearErrors("root");

    try {
      await captureSentryFeedback({
        eventId,
        file: file ?? undefined,
        message: message.trim(),
      });
    } catch {
      form.setError("root", {
        message: intl.formatMessage({
          id: "sentry.feedback.error",
          defaultMessage: "Informace se nepodařilo odeslat.",
        }),
        type: "server",
      });
    }
  };

  return (
    <BasicForm
      className="flex w-full flex-col gap-3 rounded-md border border-gray-200 p-4 text-left"
      formSchema={sentryErrorFeedbackSchema}
      onSubmit={handleSubmit}
    >
      <SentryErrorFeedbackFormFields />
    </BasicForm>
  );
}
